<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Administration / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="onAdd"
          v-if="role_modules.some(item => item.value == 'role.create')"
        >
          <i class="uil-plus mr-1"></i> Add Role
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <DataTable ref="table"/>
      </div>
    </div>
  </div>
</template>

<script>
  import DataTable from './table'

  export default {
    components: { DataTable},
    methods: {
      onAdd () {
        this.$refs.table.onShowCreate()
      }
    }
  }
</script>